export default {
    namespaced: true,

    state: {
        latvianAlphabet: [
            "A",
            "Ā",
            "B",
            "C",
            "Č",
            "D",
            "E",
            "Ē",
            "F",
            "G",
            "H",
            "I",
            "Ī",
            "J",
            "K",
            "Ķ",
            "L",
            "Ļ",
            "M",
            "N",
            "Ņ",
            "O",
            "P",
            "R",
            "S",
            "Š",
            "T",
            "U",
            "Ū",
            "V",
            "Z",
            "Ž",
        ],
    },

    getters: {
        latvianAlphabet(state) {
            return state.latvianAlphabet;
        },
    },
};
